export const BarChartAlt = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 27L30 27" stroke="currentColor" stroke-width="2"/>
<rect x="7" y="17" width="6" height="10" stroke="currentColor" stroke-width="2"/>
<rect x="13" y="11" width="6" height="16" stroke="currentColor" stroke-width="2"/>
<rect x="19" y="5" width="6" height="22" stroke="currentColor" stroke-width="2"/>
</svg>`;
